module.exports = __webpack_public_path__ + "img/email.3cf85154.svg";